import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SlimScroll} from 'angular-io-slimscroll';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SlimScroll],
  exports: [SlimScroll]
})
export class ScrollModule { }



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/shared/scroll/scroll.module.ts